import React from "react";
import "./LastSlideAstronautSlide.scss";

import PoleComponent from "../../common/components/PoleComponentEndingSlides/PoleComponent";

const LastSlideAstronautSlide = ({ onNavigateToInitialSlideFn }) => {
  return (
    <div className="vectorStoryLastSlide">
      <PoleComponent onNavigateToInitialSlideFn={onNavigateToInitialSlideFn} />
    </div>
  );
};

export default LastSlideAstronautSlide;
